export function extractAppNameFromUrl(url) {
  const APP_NOT_FOUND = 'N/A';
  try {
    const appName = new URL(url.replace('/#/', '/')).pathname.split('/')[1];
    return appName || APP_NOT_FOUND;
  } catch (error) {
    return APP_NOT_FOUND;
  }
}
